<template>
  <div class="pack_selector_container md-hide" v-dragscroll>
    <NuxtLinkLocale
      :to="`/${currentGameSlug}/${pack.slug}`"
      exact-active-class="active"
      class="pack_selector"
      v-for="pack in packs"
      :key="pack"
      @click="sendDataLayer(pack)"
    >
      <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
        {{ pack.short_title }}
      </h3>
    </NuxtLinkLocale>

    <div class="d-flex-row justify-start flex-2" v-if="faceitPacks.length > 0">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 0.829519C17 0.694625 16.85 0.653617 16.782 0.758295C14.7122 3.93638 13.5489 5.75151 12.4967 7.39829C8.58484 7.40045 2.95493 7.40153 0.154554 7.39613C0.00131546 7.39613 -0.0601958 7.5947 0.0736181 7.64542C5.19416 9.57601 12.5949 12.4865 16.7237 14.1192C16.8273 14.1624 17 14.062 17 13.9886V0.829519Z"
          fill="#FF5601"
        />
      </svg>
      <h4 class="white-space-no regular-s font-family-1 t-white f-w-600">
        {{
          $t("counter-strike-2-boost.counter-strike-2-faceit-boost.short_title")
        }}
      </h4>
    </div>

    <NuxtLinkLocale
      :to="`/${currentGameSlug}/${pack.slug}`"
      exact-active-class="active"
      class="pack_selector"
      v-for="pack in faceitPacks"
      :key="pack"
      @click="sendDataLayer(pack)"
    >
      <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
        {{ pack.short_title }}
      </h3>
    </NuxtLinkLocale>

    <TpReviews class="xl-hide" v-if="!$isMobile()" />
  </div>

  <div
    class="pack_selector_dropdown d-flex-row above-md-hide"
    v-click-outside="closeOutside"
  >
    <button
      class="primary dark plain hover active_tab medium height-48 b-radius-6 full-width space-between medium-xl font-family-2 f-w-500"
      :class="[isOpen && 'opened']"
      @click.stop="toggleDrop"
      v-if="activePack"
    >
      {{ activePack }}
      <chev-right />
    </button>

    <transition name="slide-fade-top">
      <div
        class="d-flex-column justify-start align-start packs_list gap-18"
        v-if="isOpen"
      >
        <NuxtLinkLocale
          :to="`/${currentGameSlug}/${pack.slug}`"
          v-for="(pack, index) in otherPacks"
          class="medium-xl font-family-2 t-light routes d-flex-column align-start justify-start"
        >
          {{ pack.short_title }}
          <hr class="horizontal" v-if="index !== otherPacks.length - 1" />
        </NuxtLinkLocale>
      </div>
    </transition>
  </div>
</template>

<script setup>
import ChevRight from "~/components/icons/ChevRight.vue";
import { ref, computed } from "vue";
import { useGtm } from "@gtm-support/vue-gtm";
import TpReviews from "./TpReviews.vue";
// HOOKS

const gameStore = useGameStore();
const { public: publicConfig } = useRuntimeConfig();
const { nuxtEnv } = publicConfig;
const { currentGameSlug, currentGamePackSlug } = useGameComposable();
const { getUser } = useUserStore();
const $gtm = useGtm();

// REACTIVITY
const isOpen = ref(false);

const packs = computed(() => {
  if (currentGameSlug === "counter-strike-2-boost") {
    return gameStore.getGame.packs.filter(
      (pack) => !pack.title.includes("Faceit")
    );
  }
  return gameStore.getGame.packs;
});

const faceitPacks = computed(() => {
  if (currentGameSlug === "counter-strike-2-boost") {
    return gameStore.getGame.packs.filter((pack) =>
      pack.title.includes("Faceit")
    );
  }
  return [];
});

const activePack = computed(() => {
  const activePacks = gameStore.getGame.packs.find(
    (pack) => pack.slug === currentGamePackSlug
  );
  if (activePacks) {
    return activePacks.short_title;
  }
  return "";
});

const otherPacks = computed(() => {
  if (activePack.value) {
    return gameStore.getGame.packs.filter(
      (packs) => packs.short_title !== activePack.value
    );
  }
  return this.packs;
});

const toggleDrop = () => {
  isOpen.value = !isOpen.value;
};

const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const sendDataLayer = async (pack) => {
  if (nuxtEnv === "prod" && window.dataLayer?.push) {
    let otherParams = {};
    if (getUser.id) {
      otherParams = {
        user_data: {
          first_name: getUser.username,
          email_address: getUser.email,
          user_id: getUser.id,
          customer_lifetime_spent: getUser.total_spent,
        },
      };
    }
    window.dataLayer?.push({
      event: "select_item",
      ecommerce: {
        items: [
          {
            item_id: "game_pack_" + pack.id,
            item_name: pack.title,
            affiliation: pack.slug,
            quantity: 1,
          },
        ],
      },
      ...otherParams,
    });
  }
};
</script>
